
const paginationSelectRange = 4

const debounceInterval = 300

export default {
    paginationSelectRange: paginationSelectRange,
    debounceInterval: debounceInterval
}